/** Purelytics role helpers — CEO dashboard uses superadmin only. */
export const isAdminNav = (role) => role === 'admin' || role === 'superadmin';
export const isSuperadmin = (role) => role === 'superadmin';

/** Route keys used in server role config (server/data/auth/roles.json). */
export const ROUTE_KEYS = {
  CEO: 'ceo',
  DASHBOARD: 'dashboard',
  CLIENTS: 'clients',
  LOCATIONS: 'locations',
  INSIGHTS: 'insights',
  PURE_PROMOTE: 'pure-promote',
  MARKETING: 'marketing',
  ONBOARDING: 'onboarding',
  OUTREACH: 'outreach',
  REGISTRATIONS: 'registrations',
  CLIENT_WATCHLIST: 'client-watchlist',
  USER_MANAGEMENT: 'user-management',
};
